<template>
  <h3>
    <router-link to="/Showcases" title="All VIZBI Showcase events">Showcase</router-link>
  </h3>
  <!-- v-if prevents errors when switching routes -->
  <component :is="page" v-if="$route.name" />
</template>

<script setup>
import {useRoute} from "vue-router";
import {shallowRef} from "vue";
const route = useRoute();
let page = shallowRef();
try {
  if (route.params.year && route.params.showcaseEvent) {
    const {year, showcaseEvent} = route.params;
    page = shallowRef(require(`@/assets/years/${year}/Showcase/${showcaseEvent}.vue`).default);
  }
} catch (error) {
  console.error(`ShowcaseEvent|${route.params.year} error: ${error}`);
}
</script>

<style scoped>
h3 {
  display: inline;
  line-height: 16px;
  margin-top: 22px;
}
</style>
